export const workshopSearchParams = {
  serviceDetail: {
    overview: 'overview',
    orders: 'orders',
    ownership: 'ownership',
    vehicle: 'vehicle',
    checkout: 'checkout',
    photos: 'photos',
    documents: 'documents',
    checkinHandover: 'checkinHandover',
    postponed: 'postponed',
    serviceIntervals: 'serviceIntervals',
    activeServiceCases: 'activeServiceCases',
    historyOfRepairs: 'historyOfRepairs',
    tires: 'tires',
    serviceCampaigns: 'serviceCampaigns',
    activityLogs: 'activityLogs',
    checklists: 'checklists',
    tasks: 'tasks',
  },
  create: {
    customerVehicle: 'customerVehicle',
    serviceJobs: 'serviceJobs',
    schedule: 'schedule',
  },
};
